//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axiosApi from "@/request/index";
import footerNav from "@/components/footerNav";
import { Dialog, Toast, Notify } from "vant";
import zwtp from "../../assets/img/zwtp.png";

export default {
  name: "selectSamplePM",
  components: {
    footerNav
  },
  data() {
    return {
      num: 0,
      item: {},
      loading: false,
      finished: false,
      zwtp,
      start: 0,
      size: 0,
      itemList: []
    };
  },
  created() {},
  mounted() {
    this.item = JSON.parse(this.$route.query.row);
    this.onLoad();
  },
  methods: {
    GridCheck(item) {
      item.checked = !item.checked;
      var num = 0;
      this.itemList.forEach(item => {
        if (item.checked) {
          num++;
        }
      });
      this.num = num;
    },
    onLoad() {
      this.size = this.size + 20;
      axiosApi
        .getSampleSelectProductList({
          start: this.start,
          size: this.size,
          sampleSelectId: this.item.sampleSelectId,
          orderRules: [
            {
              orderKey: "t1.sampleId",
              desc: true
            }
          ]
        })
        .then(response => {
          if (
            response.content &&
            response.content.list &&
            response.content.list.length > 0
          ) {
            response.content.list.forEach(item => {
              item.checked = false;
              if (
                item.predictedSampleCost &&
                item.predictedSampleCost != "" &&
                item.predictedSampleCost != null
              ) {
              } else {
                item.predictedSampleCost = "暂无";
              }
            });
            var List = JSON.parse(JSON.stringify(this.itemList));
            this.itemList.splice(0, this.itemList.length);
            this.itemList = response.content.list;
            this.itemList.forEach(item => {
              List.forEach(element => {
                if (element.sampleId == item.sampleId) {
                  item.checked = element.checked;
                }
              });
            });
          } else {
            this.itemList = [];
          }
          this.loading = false;
          if (this.itemList.length == response.content.total) {
            this.finished = true;
          }
        });
    },
    bottomClick(type) {
      if (type == "1") {
        this.$router.push({
          name: "activitiesSelection"
        });
      } else {
        if (this.num != 0) {
          var list = JSON.parse(this.$route.query.row);
          var arr = [];
          this.itemList.forEach(item => {
            if (item.checked) {
              arr.push({ sampleId: item.sampleId });
            }
          });
          axiosApi
            .getSampleSelectProductSelecting({
              sampleSelectId: list.sampleSelectId,
              sampleSelectColorList: arr
            })
            .then(res => {
              this.num = 0;
              this.onLoad();
            })
            .catch(err => {});
        } else {
          Notify({ type: "danger", message: "请选择" });
        }
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/centerOrder/selectSamplePM.vue